import React from 'react';
import { useSelector } from 'react-redux';
import { AvailableModals } from './modalSlice';
import { ReduxState } from '../../store';
import SetProductionModal from './SetProductionModal';
import UnsetProductionModal from './UnsetProductionModal';
import CategoryInsightsModal from './CategoryInsightsModal';
import CategoryExceptionsModal from './CategoryExceptionsModal/CategoryExceptionsModal';
import NewAppVersionModal from './NewAppVersionModal';
import ReportErrorModal from './ReportErrorModal';
import StoreOverviewModal from './StoreOverviewModal';
import ScopeEditModal from './ScopeEditModal';
import StoreScheduleModal from './StoreScheduleModal';
import StoreScheduleDeleteModal from './StoreScheduleDeleteModal';
import AiPromptModal from './AiPromptModal';
import AiPromptDeleteModal from './AiPromptDeleteModal';
import AiPromptHistoryModal from './AiPromptHistoryModal';
import ScopeAttributesEditModal from './ScopeAttributesEditModal';
import EntityListContentsModal from './EntityListContentsModal';
import EntityListSkuHandlingModal from './EntityListSkuHandlingModal';
import EntityListUnarchiveConfirmationModal from './EntityListUnarchiveConfirmationModal';
import EntityListConfigDeleteModal from './EntityListConfigDeleteModal';
import CalculationsActionModal from './CalculationsActionModal/CalculationsActionModal';
import StoreSaleInfoModal from './StoreSaleInfoModal';
import SkuDailySalesModal from './SkuDailySalesModal/SkuDailySalesModal';
import PickingLineProductGroupsModal from './PickingLineProductGroupsModal/PickingLineProductGroupsModal';
import RemovableConfigDeleteModal from './RemovableConfigDeleteModal';
import EditRedistributionModal from './EditRedistributionModal/EditRedistributionModal';
import SkuRedistributionChangelogModal from './SkuRedistributionChangelogModal/SkuRedistributionChangelogModal';
import BoxPackingPicturesModal from './BoxPackingPicturesModal/BoxPackingPicturesModal';

const ModalDisplay: React.FC = () => {
  const modalId = useSelector((state: ReduxState) => state.modal.openedModal);

  if (!modalId) return null;

  switch (modalId) {
    case AvailableModals.CATEGORY_INSIGHTS: {
      return <CategoryInsightsModal />;
    }
    case AvailableModals.CATEGORY_EXCEPTIONS: {
      return <CategoryExceptionsModal />;
    }
    case AvailableModals.ENTITY_LIST_CONTENTS: {
      return <EntityListContentsModal />;
    }
    case AvailableModals.ENTITY_LIST_SKU_HANDLING: {
      return <EntityListSkuHandlingModal />;
    }
    case AvailableModals.ENTITY_LIST_UNARCHIVE_CONFIRMATION: {
      return <EntityListUnarchiveConfirmationModal />;
    }
    case AvailableModals.ENTITY_LIST_CONFIG_DELETE: {
      return <EntityListConfigDeleteModal />;
    }
    case AvailableModals.REMOVABLE_CONFIG_DELETE: {
      return <RemovableConfigDeleteModal />;
    }
    case AvailableModals.NEW_APP_VERSION: {
      return <NewAppVersionModal />;
    }
    case AvailableModals.REPORT_ERROR: {
      return <ReportErrorModal />;
    }
    case AvailableModals.SCOPE_EDIT: {
      return <ScopeEditModal />;
    }
    case AvailableModals.STORE_SCHEDULE_EDIT: {
      return <StoreScheduleModal />;
    }
    case AvailableModals.STORE_SCHEDULE_DELETE: {
      return <StoreScheduleDeleteModal />;
    }
    case AvailableModals.AI_PROMPT_EDIT: {
      return <AiPromptModal />;
    }
    case AvailableModals.AI_PROMPT_DELETE: {
      return <AiPromptDeleteModal />;
    }
    case AvailableModals.AI_PROMPT_HISTORY: {
      return <AiPromptHistoryModal />;
    }
    case AvailableModals.SCOPE_ATTRIBUTES_EDIT: {
      return <ScopeAttributesEditModal />;
    }
    case AvailableModals.STORE_OVERVIEW: {
      return <StoreOverviewModal />;
    }
    case AvailableModals.SET_PRODUCTION: {
      return <SetProductionModal />;
    }
    case AvailableModals.UNSET_PRODUCTION: {
      return <UnsetProductionModal />;
    }
    case AvailableModals.MULTI_CALCULCATION_ACTIONS: {
      return <CalculationsActionModal />;
    }
    case AvailableModals.STORE_SALE_INFO: {
      return <StoreSaleInfoModal />;
    }
    case AvailableModals.SKU_DAILY_SALES: {
      return <SkuDailySalesModal />;
    }
    case AvailableModals.PICKING_LINE_PRODUCT_GROUPS: {
      return <PickingLineProductGroupsModal />;
    }
    case AvailableModals.EDIT_REDISTRIBUTION: {
      return <EditRedistributionModal />;
    }
    case AvailableModals.SKU_REDISTRIBUTION_CHANGELOG: {
      return <SkuRedistributionChangelogModal />;
    }
    case AvailableModals.BOX_PACKING_PICTURES: {
      return <BoxPackingPicturesModal />;
    }
    default:
      return null;
  }
};

export default ModalDisplay;
